import { IconName } from '@palmetto/dsm-components';
import pocBatteryIcon from '../../assets/point-of-contact/Battery.png';
import pocHvacIcon from '../../assets/point-of-contact/HVAC.png';
import pocSolarIcon from '../../assets/point-of-contact/Solar.png';
import pocWaterHeaterIcon from '../../assets/point-of-contact/WaterHeater.png';
import { ProjectStage, ProjectType } from './types';

export const PROJECT_TYPE_CONFIG: Record<
  ProjectType,
  { iconName: IconName; stages: ProjectStage[]; localeKey: string; showsUtilityRatePlan: boolean; pocIcon: string }
> = {
  hvac: {
    iconName: 'hvac',
    stages: ['onboarding', 'installation', 'installationVerification'],
    localeKey: 'projectDetail.pageTitle.hvac',
    showsUtilityRatePlan: false,
    pocIcon: pocHvacIcon,
  },
  solar: {
    iconName: 'solarSun',
    stages: ['onboarding', 'installation', 'installationVerification', 'activationReview'],
    localeKey: 'projectDetail.pageTitle.solar',
    showsUtilityRatePlan: true,
    pocIcon: pocSolarIcon,
  },
  consumerSolar: {
    iconName: 'solarSun',
    stages: [
      'onboarding',
      'installerMatching',
      'finalizingSystem',
      'contracting',
      'installation',
      'installationVerification',
      'activationReview',
    ],
    localeKey: 'projectDetail.pageTitle.consumerSolar',
    showsUtilityRatePlan: true,
    pocIcon: pocSolarIcon,
  },
  energyBackup: {
    iconName: 'batteryCharging',
    stages: ['onboarding', 'installation', 'installationVerification', 'activationReview'],
    localeKey: 'projectDetail.pageTitle.energyBackup',
    showsUtilityRatePlan: true,
    pocIcon: pocBatteryIcon,
  },
  waterHeater: {
    iconName: 'waterHeater',
    stages: ['onboarding', 'installation', 'installationVerification'],
    localeKey: 'projectDetail.pageTitle.waterHeater',
    showsUtilityRatePlan: false,
    pocIcon: pocWaterHeaterIcon,
  },
  geothermal: {
    iconName: 'geothermalHvac',
    stages: ['onboarding', 'loopField', 'installation', 'installationVerification'],
    localeKey: 'projectDetail.pageTitle.geothermal',
    showsUtilityRatePlan: false,
    pocIcon: pocHvacIcon,
  },
  generator: {
    iconName: 'generator',
    stages: ['onboarding', 'installation', 'installationVerification'],
    localeKey: 'projectDetail.pageTitle.generator',
    showsUtilityRatePlan: false,
    pocIcon: pocBatteryIcon,
  },
};
